import React, {useState, useEffect} from "react";
import { Switch, Route } from "react-router-dom";
import "./App.scss";
import { Redirect, useLocation, useHistory } from "react-router-dom";
import Home from "./pages/Home";
import PaymentStatus from "./pages/PaymentStatus";
import { EStatusTrip } from "./helpers/const";
import $axios from "./services/axios";
import Tracking from "./pages/Tracking";
import { message } from "antd" 

const App = () => {
  const history = useHistory();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (location.pathname === "/taxi" && !loading) {
      fetchBookingInfo();
    }
  }, [location, loading]);

  const fetchBookingInfo = async () => {
    const orderCode = localStorage.getItem("taxiIpassOrderCode");
    if (!orderCode) return;
    setLoading(true);
    try {
      const res = await $axios.$get(
        `api/v1/gsm/transactions/details?orderCode=${orderCode}`
      );
      if (res?.data?.data?.data) {
        const resTrip = await $axios.get(
          `/api/v1/gsm/trip?tripId=${res.data.data.data.tripId}`
        );
        if (resTrip?.data?.data) {
          if (
            [
              EStatusTrip.ARRIVED,
              EStatusTrip.COMING,
              EStatusTrip.FINDING,
              EStatusTrip.JOURNEY,
            ].includes(resTrip?.data?.data.status)
          ) {
            message.success("Bạn có chuyến đi chưa hoàn thành!");
            history.push(`/tracking?orderCode=${orderCode}`);
          } else {
            localStorage.removeItem("taxiIpassOrderCode");
          }
        }
      } else {
        localStorage.removeItem("taxiIpassOrderCode");
      }
    } catch (error) {
      localStorage.removeItem("taxiIpassOrderCode");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Switch>
        <Redirect exact from="/" to={"/taxi"} />
        <Route exact path={"/taxi"} render={(props) => <Home {...props} />} />
        <Route
          exact
          path={"/payment-status"}
          render={(props) => <PaymentStatus {...props} />}
        />
        <Route
          exact
          path={"/tracking"}
          render={(props) => <Tracking {...props} />}
        />
        <Redirect to={"/taxi"} />
      </Switch>
    </>
  );
};
export default App;
